// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2fG5U","title":"index-module--title--2t3Yz","body":"index-module--body--25okk","button":"index-module--button--2pslK"};